export default __webpack_public_path__ + "static/media/hero42.60391a95.jpg";